var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointOfInterestBluff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "#ffffff",
    stroke: "#8e24aa",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 14) scale(1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 20 9 7.5l4.5 7.5L16.5 10 22 20z",
    fill: "#8e24aa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointOfInterestBluff);
export default __webpack_public_path__ + "static/media/PointOfInterestBluff.c0687325c430e548ceb086f07a6f4975.svg";
export { ForwardRef as ReactComponent };